import {BehaviorSubject} from "rxjs";

export class AConfig {
  public assign(config) {
  }
}


